module.exports = __webpack_public_path__ + "static/flags/NG-617a08a04600fa6210228afb3e6d569f.gif";